import { render, staticRenderFns } from "./fakeIndex.vue?vue&type=template&id=21edd67e"
import script from "./fakeIndex.vue?vue&type=script&lang=js"
export * from "./fakeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports